var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.item
    ? _c(
        "div",
        [
          _c("ValidationObserver", {
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function({ handleSubmit }) {
                    return [
                      _c(
                        "div",
                        { staticClass: "p-4" },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "12" } }, [
                                _c("em", {
                                  staticClass:
                                    "fas fa-file-times text-orange mr-1"
                                }),
                                _c("span", { staticClass: "ml-2" }, [
                                  _vm._v("Razón de Denegación")
                                ])
                              ]),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mt-4 mt-md-2",
                                  attrs: { cols: "12", md: "4" }
                                },
                                [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: "La Razón es requerida."
                                      },
                                      rules: { required: true }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ errors }) {
                                            return [
                                              _c("CustomDropDown", {
                                                attrs: {
                                                  "custom-error-msg": errors[0],
                                                  error: errors[0],
                                                  fieldkey: "id",
                                                  fieldname: "name",
                                                  label: "Razón:",
                                                  options: _vm.viewmodel.reasons
                                                },
                                                model: {
                                                  value: _vm.model.reason,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "reason",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.reason"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mt-4 mt-md-2",
                                  attrs: { cols: "12", md: "8" }
                                },
                                [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      "custom-messages": {
                                        required:
                                          "Favor de documentar el comentario."
                                      },
                                      rules: { required: true }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ errors }) {
                                            return [
                                              _c("CustomInput", {
                                                attrs: {
                                                  error: errors[0],
                                                  label: "Comentario:"
                                                },
                                                model: {
                                                  value: _vm.model.comment,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "comment",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.comment"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mt-4 text-md-right",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _c("ActionButton", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      i: "fas fa-times-circle",
                                      text: "Cancelar",
                                      variant: "danger"
                                    },
                                    on: { click: _vm.cancel }
                                  }),
                                  _c("ActionButton", {
                                    attrs: {
                                      i: "fas fa-save",
                                      text: "Guardar",
                                      variant: "success"
                                    },
                                    on: {
                                      click: function($event) {
                                        return handleSubmit(_vm.submit)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              4222395870
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }